import { render, staticRenderFns } from "./ReservedAccounts.vue?vue&type=template&id=25c2da04&"
import script from "./ReservedAccounts.vue?vue&type=script&lang=js&"
export * from "./ReservedAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports